import { Badge, Button, Card, Flex, Image, Text } from "@mantine/core";
import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import type { JSX } from "react";
import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";
import { getBadgeIcon } from "@/sales-tools/challenges/utils/getBadgeIcon";
import quizBackground from "../../icons/QuizBackground.png?url";
import classes from "./AnnouncementStartCoverQuiz.module.css";

export function AnnouncementStartCoverQuiz({
    challenge,
    onContinueClick,
}: {
    challenge: ChallengeInfo;
    onContinueClick: () => void;
}): JSX.Element {
    dayjs.extend(utc);
    dayjs.extend(timezone);
    dayjs.tz.setDefault("America/Chicago");
    const { deadline, badgeType, details } = challenge;
    return (
        <Card w="320px" shadow="sm" padding="lg" radius="md" withBorder className={classes.cardBackground}>
            <Card.Section>
                <Image src={quizBackground} height={160} />
            </Card.Section>
            <Image
                data-testid="badge-type"
                left={0}
                top="1%"
                fit="scale-down"
                pos="absolute"
                src={getBadgeIcon(badgeType)}
                height={144}
                width={144}
            />
            <Flex direction="column" align="center" justify="center" mt="md" mb="xs">
                <Badge
                    c="dark.9"
                    color="success.5"
                    fw="var(--mantine-font-weight-heavy)"
                    fz="xs"
                    p="3xs"
                    radius="xs"
                    tt="none"
                >
                    New
                </Badge>
                <Text data-testid="announcement-challenge-type" size="lg" mt="xxs" mb="xxs" fw={300}>
                    Knowledge check
                </Text>
                <Text data-testid="announcement-header" size="18px" fw={400} ta="center">
                    Answer {details[0].conditions[0].targetValue} questions correctly to win a new badge. Ends{" "}
                    {dayjs.utc(deadline).tz("America/Chicago").format("MMMM D")}
                </Text>
            </Flex>
            <Flex justify="right">
                <Button
                    data-testid="announcement-continue-button"
                    onClick={onContinueClick}
                    mt="xl"
                    radius="xl"
                    size="sm"
                >
                    <Text size="sm" fw={400}>
                        Let’s go
                    </Text>
                </Button>
            </Flex>
        </Card>
    );
}
